import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import requestsManagerAxios from '../../../lib/requestsManagerAxios';

const styles = theme => ({
  button: {
    color: theme.palette.primary.contrastText,
    height: 48,
  },
});

const handleSignOutClick = e => {
  e.preventDefault();
  requestsManagerAxios
    .delete('/users/sign_out')
    .then(() => (window.location = '/'))
    .catch(() => location.reload());
};

const SigninSignoutButton = ({ signedIn, style, classes }) =>
  signedIn ? (
    <Button
      onClick={handleSignOutClick}
      rel="nofollow"
      style={style}
      className={classes.button}
    >
      Sign Out
    </Button>
  ) : (
    <Button className={classes.button} href="/signin">
      Admin
    </Button>
  );

SigninSignoutButton.propTypes = {
  signedIn: PropTypes.bool.isRequired,
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
};
SigninSignoutButton.defaultProps = {
  style: {},
};

export default withStyles(styles)(SigninSignoutButton);
